import moment from "moment";
import {api_format} from "../Helpers";

export const UpdatedAtColumnFormatter = (cellContent, row) => row.updated_at ? moment(row.updated_at,api_format).format('L') : " - "